import * as types from "../actions/actionTypes";
// import initialValues from '../configurations/initialValues';

export default function permissions(state = null, action) {
  switch (action.type) {
    case types.LOAD_USER_PERMISSIONS_SUCCESS:
      return [...action.permissions];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/permissionsReducer.js